/**
 * usePrevious — Returns the previous value of a variable across renders.
 *
 * Common React idiom that avoids ad-hoc `ref.current = value` mutations
 * in component bodies (which are React anti-patterns).
 *
 * Usage:
 *   const prevView = usePrevious(currentView)
 *   if (prevView !== currentView) { ... }
 */
import { useEffect, useRef } from 'react';
export function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T | undefined>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}